exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newDealPage label{margin-bottom:0}.newDealPage input.form-control{margin-bottom:15px}.newDealPage .actions .btn{margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/crm/new_deal_page.scss
// module id = 812
// module chunks = 0